import axios from 'axios';
import type { UserConfig } from '@brighterion/types/config';

/**
 * !important - configService is deprecated and needs to be deleted.
 * User Config is now stored in React Query.
 */
// eslint-disable-next-line import/no-mutable-exports
export let configService: UserConfig = {
    featureFlags: {},
    translations: {},
    tier2BankUsers: [],
    customListTypes: [],
    constants: {
        maxGlobalAggregateThreshold: 100,
        minGlobalScore: -100,
        maxGlobalScore: 100
    },
    tableauReports: []
};

let url = '';

export function initConfigService(config: Record<string, any>) {
    url = config.configUrl;
}

export const getUserConfig = async () => {
    const ruleSetId = sessionStorage.getItem('ruleSetId');
    const configUrl = ruleSetId ? `${url}/modules/default/rulesets/${ruleSetId}` : `${url}/modules/default`;
    const res = await axios.get<UserConfig>(configUrl);
    configService = { ...configService, ...res.data };
    return res.data;
};
